export default "__VITE_ASSET__CKSc3ZfR__"